<template>
  <div>
    <div class="page-header clear-filter" filter-color="black">
      <parallax
        class="page-header-image"
        style="background-image:url('img/bg_2.jpg')"
      >
      </parallax>
      <div class="container">
        <div class="content-center brand">
          <br>
          <br>
          <h1 class="h1-seo">¡Bienvenido a U4CROWD!</h1>
          <h3>Tu plataforma de inversiones inmobiliarias</h3>
        </div>
      </div>
    </div>
    
    <div class="section text-center" id="projects">
      <div class="container-fluid text-center">
        <h2 class="title">{{ $t('index.title') }}</h2>
        <h4>{{ $t('index.subtitle') }}</h4>
        <div class="col-md-12 ml-auto mr-auto">
          <div class="row collections">
            <project-list-view status="abierto"></project-list-view>
          </div>
            
        </div>
      </div>
      
      <el-divider></el-divider>

      <h3>{{ $t('index.title_closed') }}</h3>
      <div class="container-fluid text-center">
        <div class="col-md-12 ml-auto mr-auto">
            <div class="row collections">
              <project-list-view status="cerrado"></project-list-view>
            </div>
        </div>
      </div>
    </div>

    <div
        class="section section-download"
        id="about"
        data-background-color="black"
      >
        <div class="container">
          <div class="row justify-content-md-center">
            <div class="text-center col-md-12 col-lg-8">
              <h3 class="title">Nuestras Oficinas</h3>
              <h5 class="description">
                Selecciona el más cercano a ti
              </h5>
            </div>
          </div>
        </div>
        <GmapMap
              :center="map.center"
              :zoom="5"
              :options="map.options"
              map-type-id="terrain"
              style="width: 100%; height: 600px"
            >
            <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
               <h4 style="color: #000000;">{{infoContent}}</h4>
            </gmap-info-window>
            <GmapMarker
              :key="index"
              v-for="(m, index) in map.markers"
              :position="m.position"
              :clickable="true"
              :draggable="false"
              @click="toggleInfoWindow(m,index)"
            />
        </GmapMap>
      </div>
  </div>
</template>
<script>
import { Progress, Parallax, Modal, Button, Pagination } from '@/components';
import { Divider } from 'element-ui'
import Projects from './components/Projects';
import Investments from '@/providers/Investments'
const provider = new Investments()

import ProjectListView from '../pages/components/ProjectListView';

export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    [Progress.name]: Progress,
    [Divider.name]: Divider,
    Parallax,
    Modal,
    Projects,
    [Pagination.name]: Pagination,
    [Button.name]: Button,
    ProjectListView
  },
  data() {
    return {
      map: {
        center: { lat: 20.979672, lng: -89.599798 },
        markers: [{ position: {lat: 20.9796726, lng: -89.5997984 }, text: 'Mérida Yucatán'}],
        places: [],
        currentPlace: null,
        options: {
          styles: [
            {
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#1d2c4d"
                }
              ]
            },
            {
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#8ec3b9"
                }
              ]
            },
            {
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#1a3646"
                }
              ]
            },
            {
              "featureType": "administrative.country",
              "elementType": "geometry.stroke",
              "stylers": [
                {
                  "color": "#4b6878"
                }
              ]
            },
            {
              "featureType": "administrative.land_parcel",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#64779e"
                }
              ]
            },
            {
              "featureType": "administrative.province",
              "elementType": "geometry.stroke",
              "stylers": [
                {
                  "color": "#4b6878"
                }
              ]
            },
            {
              "featureType": "landscape.man_made",
              "elementType": "geometry.stroke",
              "stylers": [
                {
                  "color": "#334e87"
                }
              ]
            },
            {
              "featureType": "landscape.natural",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#023e58"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#283d6a"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#6f9ba5"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#1d2c4d"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#023e58"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#3C7680"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#304a7d"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#98a5be"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#1d2c4d"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#2c6675"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry.stroke",
              "stylers": [
                {
                  "color": "#255763"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#b0d5ce"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#023e58"
                }
              ]
            },
            {
              "featureType": "transit",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#98a5be"
                }
              ]
            },
            {
              "featureType": "transit",
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#1d2c4d"
                }
              ]
            },
            {
              "featureType": "transit.line",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#283d6a"
                }
              ]
            },
            {
              "featureType": "transit.station",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#3a4762"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#0e1626"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#4e6d70"
                }
              ]
            }
          ]
        }
      },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      paginationOpen: {
          current_page: 1,
          per_page: 2
      },
      paginationClosed: {
          current_page: 1,
          per_page: 2
      },
      paginationClosedIdx: 1,
      paginationOpenIdx: 1,
      projectsOpen: [],
      projectsClosed: [],
      api_files: this.$store.state.api
    }
  },
  created() {
    this.getOpen()
  },
  methods: {
    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.text;
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    getOpen() {
      let filters = 'status=OPEN'
      provider.getInvestmentsPublic(this.paginationOpen.per_page, this.paginationOpenIdx, null, filters).then((response) => {
        this.projectsOpen = response.data.data
        this.paginationOpen = response.data.meta.pagination
        this.getClosed()
      }).catch((err) => { })
    },
    getClosed() {
      let filters = 'status=CLOSED'
      provider.getInvestmentsPublic(this.paginationClosed.per_page, this.paginationClosedIdx, null, filters).then((response) => {
        this.projectsClosed = response.data.data
        this.paginationClosed = response.data.meta.pagination
      }).catch((err) => {})
    }
  },
  watch: {
    paginationOpenIdx(){
      this.getOpen()
    },
    paginationClosedIdx(){
      this.getClosed()
    }
  }
};
</script>
<style>
</style>
